/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetAdminBinCleanupPreviewQuery,
  GetAdminAiTokensQuery,
  GetAdminAiTokensCsvQuery,
  GetAdminAiChatMessagesQuery,
  GetAdminAiChatMessagesCsvQuery,
  PostAdminUsersSearchBody,
  PostAdminTeamsManualCreateBody,
  PostAdminPluginVersionBody,
  PostAdminBinCleanupEnabledBody,
  PostAdminUsersSearchResponse,
  PostAdminTeamsManualCreateResponse,
  PostAdminStatsRecalculateResponse,
  PostAdminPluginVersionResponse,
  PostAdminBinCleanupEnabledResponse,
  GetAdminStatsSingleResponse,
  GetAdminStatsExtendedResponse,
  GetAdminStatsAllResponse,
  GetAdminBinCleanupStatusResponse,
  GetAdminBinCleanupPreviewResponse,
  GetAdminAiTokensResponse,
  GetAdminAiChatMessagesResponse,
  GetAdminAiChatMessagesCsvResponse,
} from '../types';

export class Admin extends Controller {
  async postAdminUsersSearch<
    T extends PostAdminUsersSearchResponse,
    D,
    C extends PostAdminUsersSearchBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/admin/users/search',
      body,
      axiosConfig
    );
  }

  async postAdminTeamsManualCreate<
    T extends PostAdminTeamsManualCreateResponse,
    D,
    C extends PostAdminTeamsManualCreateBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/admin/teams/manual-create',
      body,
      axiosConfig
    );
  }

  async postAdminStatsRecalculate<
    T extends PostAdminStatsRecalculateResponse,
    D,
    C extends null
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/admin/stats/recalculate',
      body,
      axiosConfig
    );
  }

  async postAdminPluginVersion<
    T extends PostAdminPluginVersionResponse,
    D,
    C extends PostAdminPluginVersionBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/admin/plugin/version',
      body,
      axiosConfig
    );
  }

  async postAdminBinCleanupEnabled<
    T extends PostAdminBinCleanupEnabledResponse,
    D,
    C extends PostAdminBinCleanupEnabledBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/admin/bin-cleanup/enabled',
      body,
      axiosConfig
    );
  }

  async getAdminStatsSingle<T extends GetAdminStatsSingleResponse, D, C>(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/admin/stats/single',
      axiosConfig
    );
  }

  async getAdminStatsExtended<T extends GetAdminStatsExtendedResponse, D, C>(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/admin/stats/extended',
      axiosConfig
    );
  }

  async getAdminStatsAll<T extends GetAdminStatsAllResponse, D, C>(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/admin/stats/all',
      axiosConfig
    );
  }

  async getAdminBinCleanupStatus<
    T extends GetAdminBinCleanupStatusResponse,
    D,
    C
  >(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/admin/bin-cleanup/status',
      axiosConfig
    );
  }

  async getAdminBinCleanupPreview<
    T extends GetAdminBinCleanupPreviewResponse,
    D,
    C
  >(
    query: GetAdminBinCleanupPreviewQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl('/admin/bin-cleanup/preview', query),
      axiosConfig
    );
  }

  async getAdminAiTokens<T extends GetAdminAiTokensResponse, D, C>(
    query: GetAdminAiTokensQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl('/admin/ai/tokens', query),
      axiosConfig
    );
  }

  async getAdminAiTokensCsv<T, D, C>(
    query: GetAdminAiTokensCsvQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl('/admin/ai/tokens/csv', query),
      axiosConfig
    );
  }

  async getAdminAiChatMessages<T extends GetAdminAiChatMessagesResponse, D, C>(
    query: GetAdminAiChatMessagesQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl('/admin/ai/chat/messages', query),
      axiosConfig
    );
  }

  async getAdminAiChatMessagesCsv<
    T extends GetAdminAiChatMessagesCsvResponse,
    D,
    C
  >(
    query: GetAdminAiChatMessagesCsvQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl('/admin/ai/chat/messages/csv', query),
      axiosConfig
    );
  }
}
